<section class="bg-background flex items-center justify-center h-screen w-full">
  <div class="h-screen bg-cover bg-center bg-no-repeat hidden sm:block w-full">
    <img
      src="/assets/images/cover.jpg"
      alt="Cover"
      class="w-full h-full"
      style="object-fit: cover"
    />
  </div>
  <div
    class="p-4 xs:p-5 xs:m-10 md:p-8 md:m-16 min-w-[320px] xs:min-w-[360px] md:min-w-[420px] xl:min-w-[500px] bg-white shadow rounded-lg"
  >
    <div class="h-full flex flex-col items-center justify-center gap-6">
      <!-- ! TODO: Replace with logo -->
      <div class="flex flex-row items-center gap-2">
        <div
          class="flex items-center justify-center bg-black rounded-[9px] p-1 h-fit w-fit"
        >
          <img src="assets/logo.png" alt="logo" class="w-[40px] h-[40px]" />
        </div>
        <div class="flex flex-col gap-0.5 md:mr-2">
          <h2
            class="!text-[1.8rem] md:!text-[1.5rem] text-dark-text font-bold leading-none trailing-none"
          >
            {{ 'appName' | translate }}
          </h2>
          <p
            class="!text-[1.2rem] md:!text-[1rem] text-light-text font-semibold leading-none trailing-none"
          >
            {{ 'cmsDashboard' | translate }}
          </p>
        </div>
      </div>
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section>
